import { observer } from 'mobx-react-lite'
import React, { useCallback, useEffect } from 'react'
import { View, StyleSheet, Text } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import { PROJECT_SECTIONS } from '../../../../models/src/dictionaries'
import { BtButton, Spacer } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import ProjectStore from './Store'
import { Question } from './Question'
import projectsStore from '../Projects/Store'
import RootStore from '../../store'
import { sections } from './sections'
import Wrapper from '../Contractor/Wrapper'
import { HeaderButton, Toolbar } from '../../ui/molecules/Layout'
import { IconCloseSquare } from '../../assets/icons'
import { paths } from '../links'
import { GetIcon } from '../../ui/atoms/GetIcon'

interface MobileProjectFormProps {
  route: any
  navigation: any
}

export const ToolbarRight = ({ navigation }) => {
  const onClose = () => {
    if (navigation.canGoBack()) navigation.goBack()
    else navigation.navigate(paths.Console._self)
  }
  return (
    <HeaderButton
      icon={
        <GetIcon
          icon={<IconCloseSquare height="12" width="12" />}
          onPress={onClose}
        />
      }
    />
  )
}

export const MobileProjectForm: React.FC<MobileProjectFormProps> = observer(
  ({ route, navigation }) => {
    const { t } = useTranslation('global')
    const { isBusy } = RootStore
    const {
      submit,
      allSectionsFilled,
      isCurrentSectionFilled,
      mobileAddress: addressQuestion,
      initializeAllSections,
    } = ProjectStore
    const { resetRefresher } = projectsStore

    useEffect(() => {
      initializeAllSections()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSubmit = useCallback(() => {
      if (allSectionsFilled) {
        submit(
          navigation,
          resetRefresher,
          route.params?.ids,
          route.params?.projectId,
        )
      }
    }, [
      allSectionsFilled,
      navigation,
      resetRefresher,
      route.params?.ids,
      route.params?.projectId,
      submit,
    ])

    if (!addressQuestion) {
      return null
    }
    return (
      <Wrapper
        toolbar={
          <Toolbar
            headerStyle={{
              marginBottom: 0,
              borderBottomWidth: 1,
              borderBottomColor: '#E6EBEE',
              width: '100%',
              paddingHorizontal: 0,
              height: 64,
            }}
            title={t('ProjectForm.create')}
            titleTextStyle={styles.titleHeader}
            leftComponent={<View style={{ width: '33%' }} />}
            rightComponent={<ToolbarRight navigation={navigation} />}
          />
        }
        toolbarStyle={{ paddingHorizontal: 0 }}
        footer={
          <View style={styles.buttonContainer}>
            <BtButton
              onPress={handleSubmit}
              disabled={!isCurrentSectionFilled || isBusy}
              style={styles.createProjectButton}
            >
              {t('ProjectForm.create')}
            </BtButton>
          </View>
        }
      >
        <ScrollView
          contentContainerStyle={{ flexGrow: 1 }}
          // eslint-disable-next-line i18next/no-literal-string
          keyboardShouldPersistTaps="handled"
        >
          <View style={{ padding: 16 }}>
            <Text style={styles.title}>{t('ProjectForm.mobile.header')}</Text>
            <Spacer height={5} />
            <Text style={styles.subtitle}>
              {t('ProjectForm.mobile.subHeader')}
            </Text>

            <Spacer height={5} />

            <Text style={[styles.title, { fontSize: 16 }]}>
              {t(sections[PROJECT_SECTIONS.ADDRESS].title)}
            </Text>
            <Spacer height={5} />
            <Text style={styles.subtitle}>
              {t('ProjectForm.mobile.subTitle')}
            </Text>

            <Spacer height={10} />

            <Question
              section={PROJECT_SECTIONS.ADDRESS}
              question={addressQuestion}
              key={addressQuestion?.identifier}
            />
          </View>
        </ScrollView>
      </Wrapper>
    )
  },
)

const styles = StyleSheet.create({
  titleHeader: {
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Inter',
    color: '#003353',
  },
  title: {
    fontWeight: '700',
    fontSize: 18,
    lineHeight: 24,
    fontFamily: 'Inter',
    color: '#003353',
  },
  subtitle: {
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 20,
    marginBottom: 15,
    color: '#001929',
  },
  buttonContainer: {
    paddingHorizontal: 20,
    width: '100%',
    shadowOffset: {
      width: 0,
      height: -4,
    },
    shadowOpacity: 0.06,
    shadowRadius: 12,
    elevation: 4,
  },
  createProjectButton: {
    marginVertical: 16,
    width: '100%',
  },
})
